<template>
  <div class="block-jobs-list">
    <div v-if="title" class="block-jobs-list__title">
      {{ title }}
    </div>
    <AtomRichtext v-if="text" class="block-jobs-list__text is-left" :string="text" />
    <div v-if="jobData && jobData.length" class="block-jobs-list__grid">
      <BlockIndicationsItem
        v-for="job in jobData"
        :key="job.id"
        :title="job.attributes.name"
        :image="job.attributes?.teaser_image?.data?.attributes"
        :link="job.attributes.sb_slug"
      />
    </div>
    <div v-else class="block-jobs-list__no-jobs">
      {{ useTranslation('general', 'no_jobs') }}
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => { },
    },
});

/*
    Strapi data
*/
const storyStore = useStoryStore();

const strapiDataTitle = computed(() => {
    if (props.data?.strapi_data_key_title) {
        return storyStore.getConnectedStrapiValue(props.data.strapi_data_key_title);
    }

    return false;
});

const strapiDataText = computed(() => {
    if (props.data?.strapi_data_key_text) {
        return storyStore.getConnectedStrapiValue(props.data.strapi_data_key_text);
    }

    return false;
});

/*
    Texts
*/
const title = computed(() => (strapiDataTitle.value ? strapiDataTitle.value : props.data.title));
const text = computed(() => (strapiDataText.value ? strapiDataText.value : props.data.text));

/*
    Fetch data
*/
const { find } = useStrapi4();
const context = useContextStore();
const collection = ref('');
const collectionId = context.getId;

if (context.getCollection === 'api::store.store') {
    collection.value = 'stores';
} else if (context.getCollection === 'api::speaker.speaker') {
    collection.value = 'speakers';
}

const { data: jobs } = useLazyAsyncData(
    `jobs/${getUid()}`,
    () => find('jobs', {
        filters: {
            $or: [
                {
                    is_hidden: {
                        $eq: false,
                    },
                },
                {
                    is_hidden: {
                        $null: true,
                    },
                },
            ],
        },
        populate: ['teaser_image', collection.value],
    }),
);

const jobData = computed(() => {
    const jobResult = jobs?.value?.data;
    if (!jobResult) return [];

    if (props.data.show_all) return jobResult;
    const collectionJobs = jobResult.filter((job) => job.attributes[collection.value]?.data
        .map((item) => item.id).includes(collectionId));
    if (collectionJobs.length > 0) {
        return collectionJobs;
    }
    return [];
});
</script>
<style lang="scss">
.block-jobs-list {
    @include component-spacing(30px, 60px);
    @include grid-columns(1, 18);
    @include fluid('gap', 20px, 34px);

    @include tablet {
        @include grid-columns(1, 12);
    }
}

.block-jobs-list__grid {
    @include grid-layout();
    @include fluid('row-gap', 40px, 60px);

    grid-template-columns: repeat(3, 1fr);

    @include mobile {
        grid-template-columns: repeat(1, 1fr);
    }

}

.block-jobs-list__no-jobs {
    @include typo-size('p');
    @include typo-font('light');

    color: $C_GREEN_DARK;
    text-align: center;
}

.block-jobs-list__empty-message {
    font-size: 26px;
}

.block-jobs-list__title {
    @include grid-columns(1, var(--grid-columns));
    @include fluid('margin-bottom', 14px, 30px);
    @include typo-size('h2');
    @include typo-font('regular');
}

.block-jobs-list__text {
    @include default-content-columns;
    @include fluid('margin-bottom', 20px, 40px);
}
</style>
